import React from 'react'

export const AlertPropsContext = React.createContext(undefined)
export const AlertHandlersContext = React.createContext(undefined)
